import React, { Component } from 'react';
import { connect } from 'react-redux';
import { cartState, cartDispatcher, combineDispatchers, popupDispatcher, productsDispatcher, combineStates, productState, viewSettingsState, viewsState, screenState, showFooterDispatcher, siteSettingsState, mobilePageViewDispatcher, currentPageState, currentPageDispatcher, currentCartItemState, currentCartItemDispatcher, screenSizeState } from '../../../store';
import { CartItemDetail, EmptyCart, GenericViewer, CartHeader, CartFooter, SvgImage, ProductPrice, ProductDescription, ProductCode, ProductImage, IconButton, ActionPanel, BusyContainer } from '../../../components';
import { importActions, superCodeActions, translate } from '../../../services';
import { element, PropTypes } from 'prop-types';
import { ScreenType } from '../../../model';
import { PricingModule, getAccessories, getCartItems, getUserAssignments } from '../../../util';
import { Box, MenuItem, Select, IconButton as MuiIconButton, Drawer, Divider } from '@mui/material';
import { arrowLeftIcon, arrowRightIcon, DownArrowIconNew, EmptyStateIconNew, placeHoderImage, ProductMenuIconNew } from '../../../../style/images';
import { FirstPage, NavigateBefore, NavigateNext, LastPage } from '@mui/icons-material';
import { NoResultsFound } from './productViewer';
import classNames from 'classnames';
import { CbolCartInfo } from '../../../components/cart';

export class CartComponent extends Component {
  constructor() {
    super();
    this.state = {
      descending: false,
      filteredBy: null,
      orderedBy: null,
      lastUpdated: null,
      page: 0,
      rowsPerPage: 10,
      displayItems:[],
      currentProducts:[],
      toggle:false,
      isExpanded:false,
      isExpandedArray:[],
      expandedItemKeys:[],
      isFiltered:false,
      currentActionItem:null,
      showItemActions: false,
      showExternalLinks: true
    };
  }
  setProductsPerPage(){
    console.log(this.state.page, this.state.rowsPerPage)
    let results = this.displayItems();
    let products = results;
    let startIndex = (this.state.page)*this.state.rowsPerPage;
    let lastIndex = startIndex+this.state.rowsPerPage;
    products = products.slice(startIndex, lastIndex);
    if(products.length===0 && this.state.page>0){
      this.setState({page:this.state.page-1})
    }
    let { descending, filteredBy, orderedBy } = this.state;
    if ( filteredBy ) {
      // displayItems = displayItems.filter( item => orderableAttributes.any( att => item[att.value] && item[att.value].toString().includesCaseInsensitive( filteredBy ) ) );
      products = products.filter( item => (item["name"] && item["name"].toString().includesCaseInsensitive( filteredBy ) || item["code"] && item["code"].toString().includesCaseInsensitive( filteredBy ) || 
      item["description"] && item["description"].toString().includesCaseInsensitive( filteredBy ) ||item["NST_description"] && item["NST_description"].toString().includesCaseInsensitive( filteredBy )
     || item["superCodeLSO"] && item["superCodeLSO"].toString().includesCaseInsensitive( filteredBy ) ));
      
    }

    if ( orderedBy ) {
      orderedBy = orderedBy.toLowerCase();
      products.sort( ( a, b ) => {
        const sortNumber = a[orderedBy] < b[orderedBy] ? -1 : 1;
        return descending ? sortNumber * -1 : sortNumber;
      } );
    }
    console.log(startIndex, lastIndex, products)
    return products
  }
  componentDidMount() {
    this.mounted = true;
    this.setProductsPerPage();
    if(this.props.currentPage.currentPage!=="cartPage"){
      this.props.setPage("cartPage")
   }
  }

  componentDidUpdate(prevProps){
    if(prevProps.currentCartItem.showActions!==this.props.currentCartItem.showActions && this.props.currentCartItem.showActions){
      this.onToggleAction()
    }
    if(this.props.currentPage.currentPage!=="cartPage"){
      this.props.setPage("cartPage")
   }
  }
  componentWillUnmount() {
    const {updateLandingPage,landingpagecart}=this.props;
    this.mounted = false;
    landingpagecart && updateLandingPage(false);
  }

  orderBy = value => {
    const { descending, orderedBy } = this.state;
    this.mounted && this.setState( { orderedBy: value, descending: orderedBy === value ? !descending : false } );
  }

  search = filteredBy => {
    this.mounted && this.setState( { filteredBy } );
  }

  getAllAttributes( layout, attributes = [] ) {
    if ( !layout || !layout.rows && !layout.columns ) {
      return attributes;
    }
    const children = layout.rows || layout.columns;
    for ( let child of children ) {
      if ( child.property && child.property === "name" ) {

        // attributes.push( { name: translate(child.property), value: child.property } );
        attributes.push( { name: translate("Name"), value: translate("Name") } );
      }
      this.getAllAttributes( child, attributes );
    }
    return attributes;
  }
  renderEmptyCart() {
    return <div className="cart">
      <EmptyCart />
    </div>;
  }
  
  isExpandable = item => {
    if(item.configuration){
      const accessories = getAccessories( item );
      const additional_accessories=getAccessories(item.looseadditionalProduct?.firstOrDefault())
      const total_acc=accessories.concat(additional_accessories)
      if(total_acc && total_acc.length>0){return true}
      if(accessories && accessories.length>0){return true}
    }
    if ( item && item.configuration && item.bomComponents && item.bomComponents.length ) {
      return true;
    } else if( item && !item.isSuperConfiguration && !item.configuration ){
      return false;
    }
    else if(item && item.configuration){
      if(item.configuration.bomComponents && item.configuration.bomComponents.length>0){return true}
      else if(item.configuration.bomComponents && item.configuration.bomComponents.length<=0 ){return false;}
      else if(!item.configuration.bomComponents){return false;}
    }

    return true;
    // in case a variant is multivalued, we don't have to exclude that one
    // return item.configuration && getUserAssignments( item.configuration ).any( assignment => item.assignments.where( a => a.value.indexOf( ' ' ) === -1 ).none( tmpAssignment => tmpAssignment.name === `Variants.${ assignment.key }` ) );
  }

  displayItems = ()=>{
    const {cart} = this.props;
    let items=[];
    if(cart.stack && cart.stack.length>0)
      { cart.stack.forEach( key => items.push({...cart[key].product,key:key,amount: cart[key].quantity}) )};
    let displayItems = [];
    items.reduce( (displayItems, current)=>{
      if(!current.additionalProducts || current.additionalProducts && current.additionalProducts.length === 0){
        displayItems.push( current );
        return displayItems;
      }
      let superConfigurationName = current.name;
      let isSuperConfiguration = 'true';
      superConfigurationName = current.additionalProducts.reduce( ( superConfigurationName, tempProd )=>{ superConfigurationName =`${superConfigurationName}+${tempProd.name}`; return superConfigurationName;}, superConfigurationName  );
      let superConfigurationDescription = current.description;
      let additionalProductsWithAmount = current.additionalProducts.map( c => ({...c, amount: current.amount }));
      superConfigurationDescription = current.additionalProducts.reduce( ( superConfigurationDescription, tempProd )=>{ superConfigurationDescription =`${superConfigurationDescription} + ${tempProd.description}`; return superConfigurationDescription;}, superConfigurationDescription  );
      displayItems.push({imageLso:placeHoderImage, name: superConfigurationName, code : superConfigurationName, description: superConfigurationDescription, amount: current.amount, additionalProducts:[ current, ...additionalProductsWithAmount ], isSuperConfiguration, isExpandable: this.isExpandable});
      
      return displayItems;
    }, displayItems);

    return displayItems;
  }

  isExpandeditems = ()=>{
    const {cart} = this.props;

  }
  handleChangePage = async(event, newPage) => {
    console.log(newPage)
    await this.setState({page:newPage})
    console.log(this.state.page)
    this.setProductsPerPage()
  };

  handleChangeRowsPerPage = async(event) => {
    await this.setState({rowsPerPage:parseInt(event.target.value, 10)});
    await this.setState({page:0})
    this.setProductsPerPage()
  };

  displayActionBar = ()=>{
    let startIndex = (this.state.page)*this.state.rowsPerPage;
    let lastIndex = startIndex+this.state.rowsPerPage;
    let productData = this.displayItems(); 
    // productData = productsData.filter(item=>item.description);
    lastIndex = lastIndex>productData.length?productData.length:lastIndex;
    return <span className='pagination-footer'>{`${translate("Showing")} ${startIndex+1}-${lastIndex} ${translate("of")} ${productData.length}`}</span>
  }

onBack = ()=>{
  const {landingpagecart} = this.props;
  landingpagecart?window.location.href = '#/categories' : window.history.back();
}

setProducts = (products)=>{
  this.setState({products:products})
}

setShowItemActions = ()=>{
  this.setState({showItemActions:true})
}

setHideItemActions = ()=>{
  this.setState({showItemActions:false})
}

onToggleAction = (currentProduct)=>{
  if(!this.state.toggle){
    // this.setState({currentActionItem:currentProduct});
    this.setShowItemActions();
  }
  else{
    this.setState({currentActionItem:null});
    this.props.hideCartItemActions();
  }
  this.setState({toggle:!this.state.toggle})
}

setIsFiltered = (flag)=>{
  this.setState({isFiltered:flag})
}

toggleExpand = (key)=>{
  if(!this.state.expandedItemKeys.includes(key)){
    let arr = this.state.expandedItemKeys;
    arr.push(key);
    this.setState({expandedItemKeys:arr})
  }
  else{
    let arr = this.state.expandedItemKeys;
    let index = arr.indexOf(key);
    if (index > -1) {
      arr.splice(index, 1);
    }
    this.setState({expandedItemKeys:arr})
  }
}
  render() {
    this.props.showFooter();
    this.props.screenSize.width<=900 && this.props.showCart();
    const { cart, screen, views, viewSettings, items, siteSettings } = this.props;
    // if ( !Array.isArray( cart.stack ) || !cart.stack || !cart.stack.length ) {
    //   return this.renderEmptyCart();
    // }
    let { descending, filteredBy, orderedBy } = this.state;
    const viewType = views.cart;
    const screenType = ScreenType.getScreenType( screen, viewSettings.cart );
    const layout = viewSettings.cart[screenType][viewType];
    const orderableAttributes = this.getAllAttributes( layout );

    let displayItems = this.displayItems();

    if ( filteredBy ) {
      // displayItems = displayItems.filter( item => orderableAttributes.any( att => item[att.value] && item[att.value].toString().includesCaseInsensitive( filteredBy ) ) );
      displayItems = displayItems.filter( item => (item["name"] && item["name"].toString().includesCaseInsensitive( filteredBy ) || item["code"] && item["code"].toString().includesCaseInsensitive( filteredBy ) ||
       item["description"] && item["description"].toString().includesCaseInsensitive( filteredBy ) ||
       item["NST_description"] && item["NST_description"].toString().includesCaseInsensitive( filteredBy ) ||
       item["superCodeLSO"] && item["superCodeLSO"].toString().includesCaseInsensitive( filteredBy )));
    }

    if ( orderedBy ) {
      orderedBy = orderedBy.toLowerCase();
      displayItems.sort( ( a, b ) => {
        const sortNumber = a[orderedBy] < b[orderedBy] ? -1 : 1;
        return descending ? sortNumber * -1 : sortNumber;
      } );
    }

    console.log(displayItems)
    return <BusyContainer actions={['filter-active',importActions.VALIDATE, superCodeActions.CREATE]}>
          <div className="cart">
      <Box sx={{display:"flex", width:"100%", height:{md:"170px", xs:"10%"}, padding:{md:"32px 16px", xs:"16px"}, flexDirection:"column", alignItems:"flex-start",background:"#FFFFFF",borderTop:{md:"none", xs:"1px solid var(--primary-color-grey-20, #DBDBDB)"}, gap:{md:"24px",xs:"8px"}}}>
          <Box sx={{display:{md:"flex", xs:"none"}, alignItems:"center", gap:"8px"}}>
            <div className="back-button" onClick={ this.onBack } title={ translate( 'Go back' ) }>
              <Box component="img" src={arrowLeftIcon} sx={{width:"16px", height:"16px", background:{md:"none", xs:"var(--primary-color-background-tertiary-white, #F5F5F5)"}}}></Box>
              <span>{ translate( 'Back' ) }</span>
            </div>
          </Box>
          <Box className="cart-button-tray" sx={{display:{md:"flex", xs:"none"}, width:"100%", height:"70px", flexDirection:"row",justifyContent:"space-between", alignItems:"flex-start"}}>
            <Box className="cart-summary" sx={{display:"flex", height:"100%", flexDirection:"column",alignItems:"flex-start", gap:"8px" }}>
            <span className='cart-heading'>{translate('Cart')}</span>
            {PricingModule.showPrice( siteSettings.pricingModule ) && <Box sx={{display:"flex", flexDirection:"row", gap:"8px"}}
            >
               {/* <span className='cart-price-heading'>{`${translate("Total")}:`}</span> */}

               
                { PricingModule.showPrice( siteSettings.pricingModule ) && <ProductPrice fromCart fromCartFooter priceSize='big' products={ getCartItems(displayItems) } /> }
            </Box>}
           
          </Box>
          {/* <Box flexGrow={1}></Box> */}
          <Box className="cart-footer-tray" sx={{display:"flex",height:"100%", flexDirection:"row", gap:"8px", justifyContent:"center", alignItems:"center"}}>
          <CartFooter items={ this.displayItems()}/>
          {/* <CartFooter items={displayItems}></CartFooter> */}
          </Box>
          </Box>
          <Box sx={{display:{md:"none", xs:"flex"}, flexDirection:"row", width:"100%"}}>
            <Box sx={{display:"flex", flexDirection:"column", gap:"6px", width:"40%", height:"40px", alignItems:"flex-start"}}>
              <span className='medium-font'>{`${translate('Shopping List')}:`}</span>
              <span className='regular-font-black'>{displayItems.length===0?translate("No items"): displayItems.length+" "+translate("items")}</span>
            </Box>
            <Box flexGrow={1}></Box>
            {PricingModule.showPrice( siteSettings.pricingModule ) && <Box sx={{display:"flex", flexDirection:"column", gap:"6px", width:"35%",height:"40px", alignItems:"flex-end"}}>
            {/* <span className='cart-price-heading'>{`${translate("Total")}:`}</span> */}
                { PricingModule.showPrice( siteSettings.pricingModule ) && <ProductPrice fromCart fromCartFooter priceSize='big' products={ getCartItems(displayItems) } /> }
            </Box>}
          </Box>
      </Box>
      {
        displayItems.length===0 && (filteredBy===null || (this.state.isFiltered && filteredBy===""))?<NoResultsFound show isCartPage image={EmptyStateIconNew}></NoResultsFound>:<>
        <Box sx={{display:{md:"none", xs:"flex"},height:"80%", width:"100%",overflowY:"auto",overflowX:"hidden", padding:"0px, 16px", background:"rgb(245, 245, 245)"}}> 
        {/* <Grid xs={12} sx={{display:{md:"none", xs:"flex"},flexDirection:"column", height:"100%", overflowY:"none"}}>
              <Box sx={{display:"flex", height:"90", width:"100%", flexDirection:"column", gap:"8px", padding:"16px 16px", background:"var(--primary-color-background-tertiary-white, #F5F5F5)", overflowY:"auto"}}> */}
              {/* <div className='mobile-serch-product-container'>{displayItems.map((item, key)=>{return(
              !item.configuration && item.additionalProducts && item.additionalProducts.length>0?<div className='fpmp'>
                <div key={key} className='fpmp-main-product'>
                  {item.additionalProducts.map((item, key)=>{return(<div className='fixed-part'>
                    <div className='main-item'>
                      <div className='item-container' style={{width:"90%"}}>
                      <div style={{height:"max-content", width:"40%", display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                        {
                          this.isExpandable( item ) &&<Box sx={{display:"flex", flexDirection:"column", gap:"2px"}}>
                          <div className='accessory-count-badge'>
                            <span>
                              {getAccessories( item ).length}
                            </span>
                          </div>
                          <div key={ `${ key }_expander` } className={classNames("expandable-indicator icon-button",{"expanded":this.state.expandedItemKeys.includes(key)})}>
                          <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } onClick={()=>this.toggleExpand(key)} />
                          </div></Box>
                          } 
                          {
                          !this.isExpandable( item ) && <div key={ `${ key }_expander` } className="non-expandable-indicator">
                          <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } />
                          </div>
                        }
                          <ProductImage product={ item } alt={ item.productCode } className="image-container" style={{width:"40px", height:"66px"}} />
                      </div>  
                        <div className='item-section'>
                          <div className='item-details'>
                          <ProductCode { ...item } />
                          <ProductDescription product={ item } ></ProductDescription>
                          <span className='quantity'>{`${translate("Quantity")}: ${item.amount}`}</span>
                          </div>
                            <div className='item-price'>
                            <ProductPrice product={item}></ProductPrice>
                          </div>
                        </div>
                      </div>
                      <div className='item-action'>
                        <IconButton className='white-round-button' icon={ProductMenuIconNew} onClick={()=>{this.onToggle(item.name)}}></IconButton>
                      </div></div>
                  </div>)})}
                </div>
              </div>:
              <div key={key} className='mobile-search-product' style={{height:"max-content"}}>
                <div className='main-item'>
                <div className='item-container' style={{width:"90%"}}>
                <div style={{height:"max-content", width:"40%", display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                  {
                    this.isExpandable( item ) &&<Box sx={{display:"flex", flexDirection:"column", gap:"2px"}}>
                    <div className='accessory-count-badge'>
                      <span>
                        {getAccessories( item ).length}
                      </span>
                    </div>
                     <div key={ `${ key }_expander` } className={classNames("expandable-indicator icon-button",{"expanded":this.state.expandedItemKeys.includes(key)})}>
                    <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } onClick={()=>this.toggleExpand(key)} />
                    </div></Box>
                    } 
                    {
                    !this.isExpandable( item ) && <div key={ `${ key }_expander` } className="non-expandable-indicator">
                    <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } />
                    </div>
                  }
                    <ProductImage product={ item } alt={ item.productCode } className="image-container" style={{width:"40px", height:"66px"}} />
                </div>  
                  <div className='item-section'>
                    <div className='item-details'>
                    <ProductCode { ...item } />
                    <ProductDescription product={ item } ></ProductDescription>
                    <span className='quantity'>{`${translate("Quantity")}: ${item.amount}`}</span>
                    </div>
                      <div className='item-price'>
                      <ProductPrice product={item}></ProductPrice>
                    </div>
                  </div>
                </div>
                <div className='item-action'>
                   <IconButton className='white-round-button' icon={ProductMenuIconNew} onClick={()=>{this.onToggle(item.key)}}></IconButton>
                </div></div>
                {this.state.currentActionItem===item.key&&<Drawer
                anchor="bottom"
                open={this.state.toggle}
                onClose={this.onToggle}
                // BackdropProps={{sx:{background:"rgba(0, 0, 0, 0.1)"}}}
                PaperProps={{
                  sx: {
                    boxShadow:"none",
                    borderRadius: "12px 12px 0px 0px",
                    background: "var(--brand-primary-white, #FFF)"
                  }
                }}
                id={this.state.showItemActions?"showItemActions":"hideItemActions"}
                >
                  <ActionPanel showQuantityView={false} showItemActions={this.state.showItemActions} setShowItemActions={this.setShowItemActions} setHideItemActions={this.setHideItemActions} onClose={this.onToggle} mobileSearchView mobileCartView configure quantity add fromCart product={ item } onToggle={this.onToggle} />
                </Drawer>}
               {this.state.expandedItemKeys.includes(key)&&<CartItemDetail key={key} {...item}></CartItemDetail>}
              </div>)})}
              </div> */}
              {/* </Box>
          </Grid> */}
          <div class="cart-list">
            <Box sx={{width:"100%", height:"100%", overflowY:"auto"}}>
              <GenericViewer
              key={ `${ orderedBy }_${ descending }` }
              view="cart"
              detailTemplate={ CartItemDetail }
              items={displayItems}
              isExpandable={ this.isExpandable }
              className = {"mobile-grid-view"}
              cartActionsButton = { <div className='item-action'>
              <IconButton className='white-round-button' icon={ProductMenuIconNew}></IconButton>
            </div>}
            />
            </Box>
          </div >
        </Box>
      <Box sx={{display:{md:"flex", xs:"none"}, gap:"16px", flexDirection:"column", alignItems:"start", justifyContent:"start", padding:"24px 16px", background:"rgb(245, 245, 245)", width:"100%", height:displayItems.length===0 && filteredBy!==null?"100%":"max-content", paddingBottom:'49px'}}>
        <CartHeader
          onOrder={ this.orderBy }
          onSearch={ this.search }
          orderableAttributes={ orderableAttributes }
          orderedBy={ orderedBy && translate( orderedBy ) }
          setIsFiltered = {this.setIsFiltered}
          isFiltered = {this.state.isFiltered}
          screenSize = {this.props.screenSize}
          siteSettings = {this.props.siteSettings}
        />
        
        {siteSettings.displayShoppingList&&<span className='medium-font'>{`${translate('Shopping List')}: `} <span className='regular-font-black'>{displayItems.length===0?translate("No items"): displayItems.length+" "+translate("items")}</span></span>}
        {/* <span className='regular-font-black'>{displayItems.length===0?translate("No items"): displayItems.length+" "+translate("items")}</span> */}
        
        {displayItems.length===0 && filteredBy!==null?<NoResultsFound show isCartPage image={EmptyStateIconNew}></NoResultsFound>:
        <div className='product-list'> 
          <GenericViewer
            key={ `${ orderedBy }_${ descending }` }
            view="cart"
            detailTemplate={ CartItemDetail }
            items={this.setProductsPerPage()}
            isExpandable={ this.isExpandable }
          />
          
           {displayItems.length>10&&<Box width="100%" display="flex" justifyContent="start" alignItems="center" sx={{
                display: "flex",
                height: "72px",
                padding: "12px 48px",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                backgroundColor:"#FFFFFF", borderTop: "1px solid #EBEBEB", paddingX:"48px"}}  >
                    <Box width="200px" height="50%" display="flex" flexDirection="row" justifyContent="start" alignItems="center">
                      <span className='pagination-footer'>{translate("Rows Per Page:")}</span>
                      <Select value={this.state.rowsPerPage} 
                      autoWidth 
                      height="100%" 
                      onChange={this.handleChangeRowsPerPage}
                      className='current-row-font'
                      sx={{ boxShadow: 'none',  boxShadow: "none",
                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                        {
                          border: 0,
                        },
                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          border: 0,
                        }, ml:"10px" }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "top",
                            horizontal: "center"
                          },
                          transformOrigin: {
                            vertical: "bottom",
                            horizontal: "center"
                          },
                          PaperProps: {
                            sx: {
                              borderRadius:"0px",
                              bgcolor: 'white',
                              '& .Mui-selected': {
                                backgroundColor: 'white !important',
                                fontWeight: 700,
                              },
                            },
                          }
                        }}
                        >
                      <MenuItem value={30}>
                  <div className={this.state.rowsPerPage === 30 ? 'active-page-number': 'inactive-page-number'}>
                    <span className={`page-number-of-rows` + (this.state.rowsPerPage === 30 ? ` active-current-row`: '')} style={{fontSize:"14px"}}>30</span>
                    {/* <Box sx={{width:"26px", height:"1px", background: "#DBDBDB"}}></Box> */}
                  </div>    
                </MenuItem>
                <Divider variant='middle' sx={{width:"26px", height:"1px", mt:"0px !important", mb:"0px !important"}}></Divider>
                <MenuItem value={20}>
                  <div className={this.state.rowsPerPage === 20 ? 'active-page-number': 'inactive-page-number'}>
                    <span className={`page-number-of-rows` + (this.state.rowsPerPage === 20 ? ` active-current-row`: '')} style={{fontSize:"14px"}}>20</span>
                    {/* <Box sx={{width:"26px", height:"1px", background: "#DBDBDB"}}></Box> */}
                  </div>
                </MenuItem>
                <Divider variant='middle' sx={{width:"26px", height:"1px", mt:"0px !important", mb:"0px !important"}}></Divider>
                <MenuItem value={10}> 
                <div className={this.state.rowsPerPage === 10 ? 'active-page-number': 'inactive-page-number'}>
                  <span className={`page-number-of-rows` + (this.state.rowsPerPage === 10 ? ` active-current-row`: '')} style={{fontSize:"14px"}}>10</span>
                </div>
                </MenuItem>
                      </Select>
                    </Box>
                    <Box flexGrow={1} />
                    <div className='action-bar' >
                      {this.displayActionBar()}
                      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={this.state.page===0} onClick={(e)=>{this.handleChangePage(e,0)}}><FirstPage></FirstPage></MuiIconButton> 
                      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={this.state.page===0} onClick={(e)=>{this.handleChangePage(e,this.state.page-1)}}><NavigateBefore></NavigateBefore></MuiIconButton>
                      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={this.state.page===Math.ceil((displayItems.length/this.state.rowsPerPage)-1)} onClick={(e)=>{this.handleChangePage(e,this.state.page+1)}}><NavigateNext></NavigateNext></MuiIconButton>
                      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={this.state.page===Math.ceil((displayItems.length/this.state.rowsPerPage)-1)}  onClick={(e)=>{
                        console.log(parseInt((displayItems.length/this.state.rowsPerPage)-1, 10))
                        this.handleChangePage(e,Math.ceil((displayItems.length/this.state.rowsPerPage)-1))}}><LastPage
                        ></LastPage></MuiIconButton>
                    </div>
                  </Box>}
        </div>}
        
      </Box></>}
      
      <Box sx={{display:{md:"none", xs:"flex"},width:"100%", height:"10%"}}>
      
          <div className="mobile-cart-footer">
              <CartFooter items={ displayItems } mobileCartFooter={true} />
          </div>
        </Box>
        <Drawer
                anchor="bottom"
                open={this.props.currentCartItem.showActions}
                onClose={this.onToggleAction}
                // BackdropProps={{sx:{background:"rgba(0, 0, 0, 0.1)"}}}
                PaperProps={{
                  sx: {
                    boxShadow:"none",
                    borderRadius: "12px 12px 0px 0px",
                    background: "var(--brand-primary-white, #FFF)"
                  }
                }}
                id={this.state.showItemActions?"showItemActions":"hideItemActions"}
                >
                  <ActionPanel showQuantityView={false} showItemActions={this.state.showItemActions} setShowItemActions={this.setShowItemActions} setHideItemActions={this.setHideItemActions} onClose={this.onToggleAction} mobileSearchView mobileCartView configure quantity add fromCart product={ this.props.currentCartItem.item } onToggle={this.onToggleAction} />
                </Drawer>
    </div>
    </BusyContainer> 
  }
}

CartComponent.propTypes = {
  cart: PropTypes.shape( {
    items: PropTypes.array
  } ),
  getProducts: PropTypes.func.isRequired,
  products: PropTypes.shape( {} ),
  siteSettings: PropTypes.shape( {
    pricingModule: PropTypes.number.isRequired
  } )
};

export const Cart = connect( 
  combineStates( cartState, productState,screenSizeState, screenState, viewsState, viewSettingsState, siteSettingsState, currentPageState, currentCartItemState), 
  combineDispatchers( cartDispatcher, popupDispatcher, productsDispatcher, showFooterDispatcher, mobilePageViewDispatcher, currentPageDispatcher, currentCartItemDispatcher ) 
)( CartComponent );

